export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-500/5 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-500/5 blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-primary-500/3 blur-3xl"></div>
      </div>

      <div className="w-full px-4 md:px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs text-primary-400 font-medium">每日更新 · 独家爆料</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
              51暗网吃瓜
              <br />
              <span className="text-primary-500">热门人物爆料第一站</span>
            </h1>

            <p className="mt-2 text-lg md:text-xl text-foreground-500 font-heading italic">
              全网最新鲜的吃瓜内容，尽在掌握
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              聚焦51吃瓜旗下热门人物专题，涵盖台北娜娜独家爆料、莫里秀黑料揭秘、玩偶姐姐精彩视频等优质内容。暗网吃瓜每日更新人物专题，以第一手资讯和深度挖掘，为你呈现最全面、最及时的吃瓜体验。无论是最新动态还是深度回顾，这里都是吃瓜爱好者的必访之地。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <i className="ri-fire-line text-primary-500 text-lg"></i>
                <span className="text-sm text-foreground-600">每日更新 30+ 条爆料</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-user-star-line text-primary-500 text-lg"></i>
                <span className="text-sm text-foreground-600">覆盖 100+ 热门人物</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-primary-500 text-lg"></i>
                <span className="text-sm text-foreground-600">独家一手资讯来源</span>
              </div>
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#carousel"
                onClick={(e) => { e.preventDefault(); handleScroll('#carousel'); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                查看最新爆料
              </a>
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); handleScroll('#topics'); }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 hover:border-primary-400 text-foreground-600 hover:text-primary-400 font-medium text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-hashtag"></i>
                浏览热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-xl overflow-hidden gossip-glow">
              <img
                src="https://readdy.ai/api/search-image?query=A%20mysterious%20dark%20atmospheric%20scene%20with%20dramatic%20warm%20orange%20and%20red%20lighting%2C%20abstract%20geometric%20shapes%2C%20news%20headlines%20floating%20in%20the%20air%2C%20cinematic%20mood%2C%20modern%20editorial%20aesthetic%2C%20dark%20background%20with%20glowing%20accents%2C%20digital%20age%20gossip%20and%20news%20theme%2C%20no%20text%2C%20high%20contrast%2C%20professional%20photography%20style&width=960&height=720&seq=hero-main-visual&orientation=landscape"
                alt="51暗网吃瓜热门人物爆料主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}